import { API_BASE_PATH } from '../../Shared/constants';
import { getIntl } from '../../Shared/localization';

export const JOURNEY_BUILDER_SETTINGS = {
  decisionSplitGetObjectsUrl: `${API_BASE_PATH}/DecisionSplit/decision-objects/{locale}/{buID}`,
  decisionSplitGetObjectFieldsUrl: `${API_BASE_PATH}/DecisionSplit/decision-object/{objectId}/{locale}/{buID}`,
  decisionSplitGetLocalizedFieldsUrl: `${API_BASE_PATH}/DecisionSplit/localized-codes/{rootMID}`,
  decisionSplitGetUserDataUrl: `${API_BASE_PATH}/UserData/token/{rootMID}/{token}`,
  getIsHCOEnabledUrl: `${API_BASE_PATH}/Journeys/getIsHCOEnabled/{buID}`,
  journeyMetadata: `${API_BASE_PATH}/Journeys/{journeyId}/metadata/{buID}`,
  localizationUrl: `${API_BASE_PATH}/localization/{locale}`,
};

export const DEFAULT_PREVIEW_FILE_MAX_RECORD_COUNT = 10;
export const PATHS_CAPACITY = 20;

export const JOURNEY_BUILDER_FORM_NAME = 'JourneyBuilderFormName';
export const REMAINING_BRANCH_KEY = 'remainingBranchKey';

export const getDecisionSplitSteps = () => [
  {
    label: getIntl().formatMessage({
      id: 'journeyBuilder.decisionSplit_oceDigitalDecision',
    }),
    key: 'step1',
  },
];

export const getInArgumentsProperties = isSocialMessage => {
  if (isSocialMessage) {
    return ['messageType', 'messageId'];
  } else {
    return [
      'description',
      'callToAction',
      'tacticKey',
      'ftp',
      'fileLayout',
      'fileName',
      'scheduleDates',
      'timezone',
      'time',
    ];
  }
};

export const fieldDataTypes = {
  INTEGER: 'Int',
  FLOAT: 'Float',
  DATE: 'Date',
  TEXT: 'Text',
  DICT: 'Dict',
  LIST: 'List',
  DEPENDENTLIST: 'DependentList',
  DYNAMICLIST: 'DynamicList',
};



// WEBPACK FOOTER //
// ./src/JourneyBuilder/constants/JourneyBuilder.js